var render = function render(){var _vm=this,_c=_vm._self._c;return _c('svg',{staticClass:"e3-svg",attrs:{"xmlns":"http://www.w3.org/2000/svg","width":Number(_vm.size),"height":Number(_vm.size),"viewBox":"0 0 24 24"}},[_c('path',{attrs:{"fill":"currentColor","d":"M18.41 7.41L17 6l-6 6 6 6 1.41-1.41L13.83 12l4.58-4.59M12.41 7.41L11 6l-6 6 6 6 1.41-1.41L7.83 12l4.58-4.59Z"}})])
}
var staticRenderFns = []

export { render, staticRenderFns }